import { FormState } from 'ia-react-core/~/interfaces/FormState';
import UpdateFormById from 'ia-react-core/~/actions/form/UpdateFormById';

import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import get from '../../../utils/accessors/get';
import mergeState from '../../../utils/accessors/_mergeState';
import updateFormById from '../../../actions/form-fn/updateFormById';
import completeSubmitFormById from '../../../actions/form-fn/completeSubmitFormById';

export default function formReducer(state: FormState, action: CoreAction) {
  const formId = get(state, 'formId');

  switch (action.type) {
    case `${updateFormById.type}/${formId}`:
      return reduceSetFormState(state, action as UpdateFormById);
    case `${completeSubmitFormById.type}/${formId}`:
      return reduceCompleteForm(state);
    default:
      return state;
  }
}

function reduceSetFormState(state: FormState, { formState, options: { mergeBlacklist } }: UpdateFormById) {
  return mergeState(state, formState, { mergeBlacklist }) as FormState;
}

function reduceCompleteForm(state: FormState): FormState {
  return {
    ...state,
    version: state.version + 1,
  };
}
